import { actionGenerator } from '../../../utils/redux/actionGenerator';
import { TGetPostContentOffersFailed, EGetPostContentOffersActionType } from './types';
import { IPostContentRecommendedOffers } from '../../../types/postContentRecommendedOffers';

export const getPostContentOffersFailed: (id: IPostContentRecommendedOffers['id']) => TGetPostContentOffersFailed =
  actionGenerator<EGetPostContentOffersActionType.Failed, IPostContentRecommendedOffers['id']>(
    EGetPostContentOffersActionType.Failed,
  );
